import { Component, OnInit, OnDestroy, HostListener, ElementRef, ViewChild, Inject, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, ValidatorFn, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpService } from 'src/app/services/http.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { URLUtils } from 'src/app/urlUtils';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxSpinnerService } from 'ngx-spinner';
declare var Razorpay: any;

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    //NgxSpinnerService
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss',
})
export class SettingsComponent {

  @ViewChild('bankNameInput')
  bankNameInput!: ElementRef<HTMLInputElement>;

  @ViewChild('accountNumberInput')
  accountNumberInput!: ElementRef<HTMLInputElement>;

  @ViewChild('confirmAccountNumberInput')
  confirmAccountNumberInput!: ElementRef<HTMLInputElement>;

  @ViewChild('deleteEmailInput')
  deleteEmailInput!: ElementRef<HTMLInputElement>;

  // ─── Bank Account Details modal (Subscription Details tab) ─────────────────
  bankAccountForm!: FormGroup;
  showBankAccountModal: boolean = false;
  bankAccountModalMode: 'add' | 'view' | 'edit' = 'add';
  isBankAccountVerifying: boolean = false;
  isBankAccountSubmitting: boolean = false;
  isBankAccountVerified: boolean = false;
  isBankFieldsLocked: boolean = false;
  bankVerifyMessage: string = '';
  bankVerifyError: string = '';
  bankTermsAccepted: boolean = false;
  showAccountNumber: boolean = false;
  showConfirmAccountNumber: boolean = false;
  private readonly bankNamePattern = /^[A-Za-z.& ]+$/;
  private readonly accountNumberPattern = /^\d{9,18}$/;
  private readonly ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  private readonly accountHolderNamePattern = /^[A-Za-z.\s]+$/;

  // ─── Bank Account Details — dedicated GET /v3/bank-account (View/Manage flow) ──
  /** Raw record returned by GET /v3/bank-account. null = no bank account saved yet. */
  bankAccountDetails: any = null;
  /** True once the single, one-time GET /v3/bank-account call (per Subscription
   *  Details tab load) has resolved — used to avoid flashing the wrong CTA card. */
  bankAccountFetched: boolean = false;
  /** "Discard your changes?" confirmation, shown when closing/cancelling out of
   *  Edit Mode with unsaved changes. Reuses the existing wa-confirm-* dialog styles. */
  showBankDiscardConfirm: boolean = false;
  private bankFormSnapshot: any = null;
  basic_profile: any;
  subscription_details: any;

  // ═══════════ PASSWORD MODAL STATE ═══════════
  showPasswordModal = false;
  passwordForm: any;
  showCurrentPwd = false;
  showNewPwd = false;
  showConfirmPwd = false;
  isCurrentPwdReadonly = true;
  isNewPwdReadonly = true;
  isConfirmPwdReadonly = true;
  isPasswordSubmitting = false;
  passwordChangeError: string | null = null;

  // ═══════════ LOGOUT CONFIRM STATE ═══════════
  showLogoutConfirm = false;
  logoutTarget: 'single' | 'all' | null = null;
  logoutDeviceName: string | null = null;
  logoutDeviceId: string | null = null; // set this if you pass a real device id instead of name
  isLoggingOut = false;

  // ═══════════ DELETE ACCOUNT STATE ═══════════
  showDeleteAccountConfirm = false;
  deleteConfirmEmailInput = '';
  currentUserEmail: any; // populate from your user/session service
  ownedWorkspace = {
    name: "Dhivyalakshmi K's Space",
    plan: 'Free Plan',
    memberCount: 1
  };
  ownedWorkspacesCount = 1;
  isDeletingAccount = false;
  setLog: any = {};
  termsAcceptedOn: any;
  security: any = {};
  loginTypeLog: any[] = [];
  city:any;

  profuid = localStorage.getItem('profuid')
  showPlanModal: boolean          = false;
  planModalMode: 'upgrade' | 'downgrade' | null = null;
  planModalLoading: boolean       = false;
  planModalData: any              = null;
  planOptions: any[]              = [];
  selectedPlanKey: string         = '';
  isPlanSubmitting: boolean       = false;
  downgradeReason: string         = '';
  downgradeReasonError: string    = '';
  role: any = '';
  currentDeviceId: string | null = '';
  
  showCancelSubscriptionModal = false;
  showeMandateSubscriptionModal = false;
  isCancellingSubscription = false;
  cancelSubscriptionError: string | null = null;
  userId=localStorage.getItem('user_id');
  currentUserId = localStorage.getItem('prof_id');

  constructor(
    private fb: FormBuilder,
    private spinnerService: NgxSpinnerService,
    private httpservice: HttpService,
    private confirmationDialogService: ConfirmationDialogService,
    private router: Router, private ngZone: NgZone,
    private route: ActivatedRoute,
    private toast: ToastrService,
  ) { }

  ngOnInit() {
    // this.initBankAccountForm();
    // this.loadBankAccountDetails();
    this.getSettingsLog();
    //this.getLoginTypeLog();

    this.passwordForm = this.fb.group({
      current_password: ['', Validators.required],
      //new_password: ['', [Validators.required, Validators.minLength(8)]],
      new_password: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&]).*$/)
        ]
      ],
      confirm_password: ['', Validators.required]
    }, { validators: this.passwordMatchValidator });

    //this.currentUserEmail = localStorage.getItem('user_email')
    this.currentUserEmail = localStorage.getItem('user_email') || JSON.parse(localStorage.getItem('user_email') || '""');
    // console.log('Current user email:', this.currentUserEmail);

    this.currentDeviceId = localStorage.getItem('device_id');
    this.role = localStorage.getItem('role')

  }

  getSettingsLog() {
     this.spinnerService.show();
    this.httpservice.sendGetRequest(URLUtils.getSettings).subscribe({
      next: (res: any) => {
        this.spinnerService.hide();
        this.setLog = res.data.subscription;
        console.log('Subscription details:', this.setLog);
        this.termsAcceptedOn = res.data.terms?.accepted_at;
        this.security = res.data.security;
        this.loginTypeLog = res.data.logged_in_devices;

        const currentPwdControl = this.passwordForm.get('current_password');

        if (this.security?.flow === 'setup') {
          currentPwdControl?.clearValidators();
          currentPwdControl?.setValue('');
        } else {
          currentPwdControl?.setValidators([Validators.required]);
        }

        currentPwdControl?.updateValueAndValidity();

      },
      error: () => {
        this.spinnerService.hide();
      }
    });
  }


  // getLoginTypeLog() {
  //   let uid: any = localStorage.getItem('user_id')

  //   this.httpservice.sendadminGetRequest(URLUtils.getLoginType(uid)).subscribe({
  //     next: (res: any) => {
  //       this.loginTypeLog = res.data.;
  //       // console.log('Login type response:', res);
  //     },
  //     error: () => {
  //     }
  //   });
  // }

// getStatusClass(status: string): string {
//   switch (status) {
//     case 'TRIAL':
//     case 'ACTIVE':
//       return 'text-success bg-success-subtle';

//     case 'CANCELLED':
//     case 'TRIAL_EXPIRED':
//     case 'EXPIRED':
//       return 'text-danger bg-danger-subtle';

//     default:
//       return '';
//   }
// }
getStatusClass(status: string): string {
  switch (status) {
    case 'Active':
      return 'text-success bg-success-subtle';

    case 'InActive':
      return 'text-danger bg-danger-subtle';

    default:
      return '';
  }
}

formatStatus(status: string): string {
  return status
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

  onSubscribe() {
    this.router.navigate(['/subscribe']);
  }

  eMandate(): void {

    console.log('Pending eMandate:', this.setLog);

    this.showUpgradeSuccessDialog(
      null,
      null,
      this.setLog
    );
  }

  // showUpgradeSuccessDialog(
  //   response: any,
  //   paymentResponse: any,
  //   plan: any
  // ): void {

  //   this.confirmationDialogService.confirm(
  //     'Proration Payment Successful!',

  //     `Click continue to securely register your automatic recurring setup (eMandate) for new plan ${plan?.name}.`,

  //     false,       // displayCancelButton
  //     'Continue',  // btnOkText
  //     'Cancel',    // btnCancelText
  //     true,        // isSuccess
  //     'sm'         // dialogSize

  //   ).then((confirmed: boolean) => {

  //     if (confirmed) {

  //       // User clicked Continue
  //       // NOW call Subscription API

  //       this.authorizeUpgrade(
  //         null,
  //         null,
  //         plan
  //       );

  //     } else {

  //       this.toast.info(
  //         'Process paused. Please finish eMandate execution to implement changes.'
  //       );

  //     }

  //   }).catch(() => {

  //     this.toast.info(
  //       'Process paused. Please finish eMandate execution to implement changes.'
  //     );

  //   });
  // }
  showUpgradeSuccessDialog(
  response: any,
  paymentResponse: any,
  plan: any
): void {

  this.confirmationDialogService.confirm(
    'Proration Payment Successful!',

    `Click continue to securely register your automatic recurring setup (eMandate) for new plan ${plan?.name}.`,

    false,
    'Continue',
    'Cancel',
    true,
    'sm'

  ).then((confirmed: boolean) => {

    if (confirmed) {

      // Check direct checkout first
      if (plan?.emandate?.direct_checkout === true) {

        console.log(
          'Direct checkout enabled. Skipping Subscription API.'
        );

        // Directly open existing eMandate checkout
        this.openPendingEmandateCheckout({
          data: {
            checkout_options: plan?.emandate?.checkout_options
          }
        });

        return;
      }

      // Normal flow
      // direct_checkout = false
      this.authorizeUpgrade(
        null,
        null,
        plan
      );

    } else {

      this.toast.info(
        'Process paused. Please finish eMandate execution to implement changes.'
      );

    }

  }).catch(() => {

    this.toast.info(
      'Process paused. Please finish eMandate execution to implement changes.'
    );

  });
}

  authorizeUpgrade(
    response: any,
    paymentResponse: any,
    plan: any
  ): void {

    console.log('Plan:', plan);

    const payload = {
      plan_id: plan?.plan.plan_id,
      user_id: this.currentUserId,
      upgrade: true,
      users_allowed: 1,
    };

    console.log(
      'Subscription Payload:',
      payload
    );

    this.httpservice.sendIMPostRequest(
      URLUtils.Subscription,
      payload
    ).subscribe({

      next: (authResponse: any) => {

        console.log(
          'SUBSCRIPTION RESPONSE:',
          authResponse
        );

        // Subscription API completed
        // Now open Razorpay

        this.openPendingEmandateCheckout(
          authResponse
        );
      },

      error: (err: any) => {

        console.error(
          'Subscription API failed:',
          err
        );

        this.toast.error(
          err?.error?.msg ||
          err?.error?.data?.msg ||
          'Failed to start subscription.'
        );
      }

    });
  }

  openPendingEmandateCheckout(authResponse: any): void {

    console.log('Opening eMandate checkout:', authResponse);

    const paymentData =
      authResponse?.data || authResponse;

    const checkoutOptions =
      paymentData?.checkout_options;

    if (!checkoutOptions) {

      console.error(
        'eMandate checkout_options missing:',
        authResponse
      );

      this.toast.error(
        'eMandate payment details could not be loaded.'
      );

      return;
    }

    const options: any = {

      ...checkoutOptions,

      handler: (paymentResponse: any) => {

        console.log(
          'eMandate successful:',
          paymentResponse
        );

        this.ngZone.run(() => {

          this.toast.success(
            'eMandate setup completed successfully.'
          );

          this.getSettingsLog();

        });

      },

      modal: {

        ondismiss: () => {

          this.ngZone.run(() => {

            this.toast.info(
              'eMandate setup was cancelled.'
            );

          });

        }

      }

    };

    try {

      const rzp = new Razorpay(options);

      rzp.on(
        'payment.failed',
        (failResponse: any) => {

          this.ngZone.run(() => {

            this.toast.error(
              failResponse?.error?.description ||
              'eMandate authorization failed.'
            );

          });

        }
      );

      rzp.open();

    } catch (error) {

      console.error(
        'Failed to open Razorpay:',
        error
      );

      this.toast.error(
        'Unable to open eMandate payment gateway.'
      );
    }
    // this.getSettingsLog();
  }


  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

      const newPassword = control.get('new_password')?.value;
      const confirmPassword = control.get('confirm_password')?.value;

      if (!confirmPassword) {
        return null;
      }

      if (newPassword !== confirmPassword) {
        return { passwordMismatch: true };
      }

      return null;
    };
  }
  
  // ─────────────────────────────────────────────
  // PASSWORD MODAL
  // ─────────────────────────────────────────────
  openPasswordModal(): void {
    this.passwordForm.reset();
    this.passwordChangeError = null;
    this.showCurrentPwd = false;
    this.showNewPwd = false;
    this.showConfirmPwd = false;
    this.isCurrentPwdReadonly = true;
    this.isNewPwdReadonly = true;
    this.isConfirmPwdReadonly = true;
    this.showPasswordModal = true;
  }
  closePasswordModal(): void {
    if (this.isPasswordSubmitting) return;
    this.showPasswordModal = false;
  }

  submitPasswordChange(): void {
    if (this.passwordForm.invalid) {
      this.passwordForm.markAllAsTouched();
      return;
    }

    this.isPasswordSubmitting = true;
    this.passwordChangeError = null;

    const formValue = this.passwordForm.getRawValue();

    const payload: any = {
      new_password: formValue.new_password,
      confirm_password: formValue.confirm_password
    };

    if (this.security?.flow === 'change') {
      payload.current_password = formValue.current_password;
    }
    //console.log('Payload for password change:', payload);

    this.httpservice.sendPostRequest(URLUtils.changePassword, payload).subscribe({
      next: (res: any) => {
        //console.log(res);
        this.isPasswordSubmitting = false;
        this.showPasswordModal = false;
        this.getSettingsLog();
        this.toast.success(res.msg);
      },
      error: (err: any) => {
        console.error('errrrr',err);
        this.isPasswordSubmitting = false;
        this.showPasswordModal = true;
        this.passwordChangeError = err?.error?.msg ||  err?.error?.errors?.[0]?.msg || 'Failed to update password. Please try again.';
      }
    });

    // TEMP placeholder — remove once service is wired
    // setTimeout(() => {
    //   this.isPasswordSubmitting = false;
    //   this.showPasswordModal = false;
    // }, 800);
  }

  // ─────────────────────────────────────────────
  // LOG OUT
  // ─────────────────────────────────────────────

  openLogoutConfirm(type: 'single' | 'all', device?: any) {
    //console.log('openLogoutConfirm called with type:', type, 'device:', device);
    this.logoutTarget = type;
    this.logoutDeviceName = device.device_name;
    this.logoutDeviceId = device.device_id;
    this.showLogoutConfirm = true;
  }
  cancelLogout(): void {
    if (this.isLoggingOut) return;
    this.showLogoutConfirm = false;
    this.logoutTarget = null;
    this.logoutDeviceName = null;
    this.logoutDeviceId = null;
  }

  confirmLogout(): void {
    this.isLoggingOut = true;

    if (this.logoutTarget === 'all') {
      let device ={
        "device_id": localStorage.getItem('device_id') || '',
        "logout_others": true
      }

      this.httpservice.sendPostRequest(URLUtils.logoutDevice, device).subscribe({
        next: (res: any) => {
          this.isLoggingOut = false;
          this.showLogoutConfirm = false;
          this.toast.success('All other devices have been logged out.');
        },
        error: (err: any) => {
          this.isLoggingOut = false;
          this.toast.error('Failed to log out other devices.');
        }
      });
    } else {
      let device = {
        "device_id": this.logoutDeviceId || '',
      }

      this.httpservice.sendPostRequest(URLUtils.logoutDevice, device).subscribe({
        next: (res: any) => {
          const isCurrentDevice = this.logoutDeviceId === localStorage.getItem('device_id');

          if (isCurrentDevice) {
            // Logout the application
            this.logoutApplication();
            return;
          }

          this.isLoggingOut = false;
          this.showLogoutConfirm = false;
          this.toast.success('This device has been logged out successfully.');
        },
        error: (err: any) => {
          this.isLoggingOut = false;
          this.toast.error('Failed to log out this device.');
        }
      });
    }
    this.getSettingsLog();

    // TEMP placeholder — remove once service is wired
    setTimeout(() => {
      this.isLoggingOut = false;
      this.showLogoutConfirm = false;
    }, 800);
  }

  logoutApplication(): void {

  // Clear local/session storage
  localStorage.clear();
  sessionStorage.clear();

  // Navigate to login
  this.router.navigate(['/login']);

  // Optional
  this.toast.success('You have been logged out successfully.');
}

  // ─────────────────────────────────────────────
  // DELETE ACCOUNT
  // ─────────────────────────────────────────────
  openDeleteAccountModal(): void {
    this.deleteConfirmEmailInput = '';//this.currentUserEmail;
    this.showDeleteAccountConfirm = true;

    setTimeout(() => {
      this.deleteEmailInput?.nativeElement.focus();
    });
  }

  cancelDeleteAccount(): void {
    if (this.isDeletingAccount) return;
    this.showDeleteAccountConfirm = false;
    this.deleteConfirmEmailInput = '';
  }

  confirmDeleteAccount(): void {
    // console.log('Delete button clicked');
    // console.log('Entered:', this.deleteConfirmEmailInput);

    if (this.deleteConfirmEmailInput !== this.currentUserEmail) {
      console.log('Email mismatch');
      this.toast.error('Entered email does not match your account email.');
      return;
    }
    this.isDeletingAccount = true;

    this.httpservice.sendPostRequest(URLUtils.deleteAccount, {}).subscribe({
      next: (res: any) => {
        //console.log(res);
        this.toast.success(res.msg);
        this.isDeletingAccount = false;
        this.router.navigate(['/login']);
      },
      error: (err: any) => {
        this.isDeletingAccount = false;
        this.toast.error(err?.error?.message || 'Failed to delete account. Please try again.');
      }
    });

    // TEMP placeholder — remove once service is wired
    setTimeout(() => {
      this.isDeletingAccount = false;
      this.showDeleteAccountConfirm = false;
    }, 800);
  }

  // ═══════════════════════════════════════════════════════════
  //  BANK ACCOUNT DETAILS — Subscription Details tab
  // ═══════════════════════════════════════════════════════════

  /** Group-level validator: keeps Confirm Account Number in sync with Account Number in real time */
  private accountNumbersMatchValidator(group: AbstractControl): { [key: string]: boolean } | null {
    const accCtrl = group.get('account_number');
    const confirmCtrl = group.get('confirm_account_number');
    if (!accCtrl || !confirmCtrl) return null;

    const accNum = accCtrl.value;
    const confirmNum = confirmCtrl.value;

    if (accNum && confirmNum && accNum !== confirmNum) {
      confirmCtrl.setErrors({ ...(confirmCtrl.errors || {}), mismatch: true });
      return { accountNumberMismatch: true };
    }

    if (confirmCtrl.hasError('mismatch')) {
      const remaining = { ...confirmCtrl.errors };
      delete remaining['mismatch'];
      confirmCtrl.setErrors(Object.keys(remaining).length ? remaining : null);
    }
    return null;
  }

  initBankAccountForm(): void {
    this.bankAccountForm = this.fb.group({
      account_holder_name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.accountHolderNamePattern)]],
      bank_name: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.bankNamePattern)]],
      account_number: ['', [Validators.required, Validators.pattern(this.accountNumberPattern)]],
      confirm_account_number: ['', [Validators.required, Validators.pattern(this.accountNumberPattern)]],
      ifsc_code: ['', [Validators.required, Validators.pattern(this.ifscPattern)]],
      branch_name: [{ value: '', disabled: true }]
    }, { validators: this.accountNumbersMatchValidator });

    // Auto-uppercase IFSC as the user types
    this.bankAccountForm.get('ifsc_code')?.valueChanges.subscribe((val: string) => {
      if (val && val !== val.toUpperCase()) {
        this.bankAccountForm.get('ifsc_code')?.setValue(val.toUpperCase(), { emitEvent: false });
      }
    });

    // Any edit to verification-sensitive fields invalidates a prior successful verification
    ['bank_name', 'account_number', 'confirm_account_number', 'ifsc_code'].forEach(name => {
      this.bankAccountForm.get(name)?.valueChanges.subscribe(() => {
        if (this.isBankAccountVerified && !this.isBankFieldsLocked) {
          this.isBankAccountVerified = false;
          this.bankVerifyMessage = '';
        }
      });
    });
  }

  /** Whether the Verify button should be enabled */
  get canVerifyBankAccount(): boolean {
    const f = this.bankAccountForm;
    if (!f || this.isBankAccountVerifying || this.isBankFieldsLocked) return false;
    return !!(
      f.get('account_number')?.valid &&
      f.get('confirm_account_number')?.valid &&
      !f.hasError('accountNumberMismatch') &&
      f.get('ifsc_code')?.valid
    );
  }

  /** Whether Submit should be enabled */
  get isBankSubmitEnabled(): boolean {
    return !!(this.bankAccountForm?.valid && this.isBankAccountVerified && this.bankTermsAccepted && !this.isBankAccountSubmitting);
  }

  /** Strips non-digit characters as the user types (Account Number / Confirm Account Number) */
  sanitizeNumericInput(controlName: 'account_number' | 'confirm_account_number'): void {
    const ctrl = this.bankAccountForm.get(controlName);
    if (!ctrl) return;
    const cleaned = (ctrl.value || '').toString().replace(/\D/g, '').slice(0, 18);
    if (cleaned !== ctrl.value) {
      ctrl.setValue(cleaned);
    }
  }

  /** Prevents Enter from submitting the Bank Account form while typing in a text field,
   *  while still letting Enter/Space activate a focused button (e.g. Verify). */
  blockEnterOnInput(event: Event): void {
    const target = event.target as HTMLElement | null;
    if (target && target.tagName === 'INPUT') {
      event.preventDefault();
    }
  }

  toggleAccountNumberVisibility(): void {
    this.showAccountNumber = !this.showAccountNumber;
  }

  toggleConfirmAccountNumberVisibility(): void {
    this.showConfirmAccountNumber = !this.showConfirmAccountNumber;
  }

  /** GET /v3/bank-account — called once per Subscription Details tab load (see
   *  switchTab / handleCompleteNow) and again after a successful save, so the
   *  Subscription Details card and the dialog's View mode always reflect the
   *  latest saved record without reloading the whole page. */
  loadBankAccountDetails(): void {
    // Safety net: subscription_details.bank_account (from the main extendedProfile
    // call) is the source that reliably reflects an already-saved bank account.
    // If the dedicated GET below is unavailable, errors, or returns a shape we
    // don't recognise, we fall back to it instead of incorrectly showing "Add".
    const profileFallback = this.subscription_details?.bank_account || null;

    this.httpservice.sendGetRequest(URLUtils.bankAccountGet).subscribe({
      next: (res: any) => {
        this.bankAccountFetched = true;
        if (res?.error === true) {
          this.bankAccountDetails = profileFallback;
          return;
        }
        let data = res?.data?.account_details ?? res?.data?.bank_account ?? res?.data ?? null;
        if (Array.isArray(data)) {
          data = data[0] || null;
        }
        const hasAccount = !!(data && typeof data === 'object' && Object.keys(data).length &&
          (data.account_number || data.ifsc_code || data.bank_name || data.account_holder_name));
        if (hasAccount) {
          // Normalize the API's `verification_status` into the `is_verified`
          // flag the rest of this component (View badge, Edit-mode locking)
          // already reads — the original field is kept alongside it.
          data = { ...data, is_verified: data.is_verified ?? data.verification_status };
        }
        this.bankAccountDetails = hasAccount ? data : profileFallback;
      },
      error: () => {
        // The dedicated endpoint may 404 or not be wired up in every environment —
        // that alone doesn't mean the user has no bank account on file.
        this.bankAccountFetched = true;
        this.bankAccountDetails = profileFallback;
      }
    });
  }

  /** Masked Account Number for View mode display only, e.g. "**********9012".
   *  The real value never gets a chance to render in View mode. */
  get maskedBankAccountNumber(): string {
    const num = (this.bankAccountDetails?.account_number || '').toString();
    if (!num) return '';
    if (num.length <= 4) return num;
    return '*'.repeat(num.length - 4) + num.slice(-4);
  }

  /** Opens the modal. mode='view' shows the read-only, masked details fetched
   *  via GET /v3/bank-account. mode='add' opens a blank form as before. */
  openBankAccountModal(mode: any) {
    // console.log('clicked');
    // console.log('mode',mode)

    this.resetBankAccountForm();
    this.bankAccountModalMode = mode;

    const holderName = this.basic_profile?.name || '';
    this.bankAccountForm.get('account_holder_name')?.setValue(holderName || '');

    this.showBankAccountModal = true;
  }

  /** Switches the already-open dialog from View mode into Edit mode in place —
   *  no second dialog is opened. Pre-fills and locks the form exactly like a
   *  freshly-verified Add flow, matching the existing verify/lock/unlock logic. */
  switchToEditMode(): void {
    const existing = this.bankAccountDetails;
    if (!existing) return;

    this.resetBankAccountForm();
    this.bankAccountModalMode = 'edit';

    const holderName = this.basic_profile?.name || '';
    this.bankAccountForm.get('branch_name')?.enable({ emitEvent: false });
    this.bankAccountForm.patchValue({
      account_holder_name: existing.account_holder_name || holderName || '',
      bank_name: existing.bank_name || '',
      account_number: existing.account_number || '',
      confirm_account_number: existing.account_number || '',
      ifsc_code: existing.ifsc_code || '',
      branch_name: existing.branch_name || ''
    });

    if (existing.is_verified !== false) {
      this.isBankAccountVerified = true;
      this.bankVerifyMessage = 'Bank account verified successfully.';
      this.lockVerifiedBankFields();
    }
    this.bankTermsAccepted = true;

    // Snapshot the just-populated state so Cancel/Close can tell a real edit
    // apart from simply entering and leaving Edit mode untouched.
    this.bankFormSnapshot = { ...this.bankAccountForm.getRawValue(), __terms: this.bankTermsAccepted };
  }

  /** True when the user has actually changed something while in Edit mode. */
  private isBankFormDirty(): boolean {
    if (!this.bankFormSnapshot) return false;
    const current = { ...this.bankAccountForm.getRawValue(), __terms: this.bankTermsAccepted };
    return JSON.stringify(current) !== JSON.stringify(this.bankFormSnapshot);
  }

  /** Entry point for the X button, backdrop click, and footer Cancel button.
   *  Only Edit mode with unsaved changes is gated behind a confirmation —
   *  Add mode and View mode close immediately, exactly as before. */
  requestCloseBankAccountModal(): void {
    if (this.isBankAccountSubmitting) return;
    if (this.bankAccountModalMode === 'edit' && this.isBankFormDirty()) {
      this.showBankDiscardConfirm = true;
      return;
    }
    this.closeBankAccountModal();
  }

  keepEditingBankAccount(): void {
    this.showBankDiscardConfirm = false;
  }

  confirmDiscardBankChanges(): void {
    this.showBankDiscardConfirm = false;
    this.closeBankAccountModal();
  }

  closeBankAccountModal(): void {
    if (this.isBankAccountSubmitting) return;
    this.showBankAccountModal = false;
    this.showBankDiscardConfirm = false;
  }

  resetBankAccountForm(): void {
    this.isBankAccountVerifying = false;
    this.isBankAccountSubmitting = false;
    this.isBankAccountVerified = false;
    this.isBankFieldsLocked = false;
    this.bankVerifyMessage = '';
    this.bankVerifyError = '';
    this.bankTermsAccepted = false;
    this.showAccountNumber = false;
    this.showConfirmAccountNumber = false;
    this.bankAccountModalMode = 'add';
    this.showBankDiscardConfirm = false;
    this.bankFormSnapshot = null;

    this.bankAccountForm.reset();
    ['account_holder_name', 'bank_name', 'account_number', 'confirm_account_number', 'ifsc_code'].forEach(name => {
      this.bankAccountForm.get(name)?.enable({ emitEvent: false });
    });
    this.bankAccountForm.get('branch_name')?.disable({ emitEvent: false });
  }

  /** Locks only the fields tied to IFSC verification. Bank Name/Branch Name stay editable
   *  after a successful verify, per the approved UX (user may correct them if needed). */
  private lockVerifiedBankFields(): void {
    this.isBankFieldsLocked = true;
    ['account_number', 'confirm_account_number', 'ifsc_code'].forEach(name => {
      this.bankAccountForm.get(name)?.disable({ emitEvent: false });
    });
  }

  /** Lets the user unlock and re-verify an already-verified set of bank details */
  unlockBankFieldsForEdit(): void {
    this.isBankFieldsLocked = false;
    this.isBankAccountVerified = false;
    this.bankVerifyMessage = '';
    this.bankVerifyError = '';
    this.bankAccountForm.get('branch_name')?.setValue('');
    this.bankAccountForm.get('branch_name')?.disable({ emitEvent: false });
    ['account_number', 'confirm_account_number', 'ifsc_code'].forEach(name => {
      this.bankAccountForm.get(name)?.enable({ emitEvent: false });
    });
  }

  verifyBankAccount(): void {
    if (this.isBankAccountVerifying || this.isBankFieldsLocked) return;

    this.bankVerifyError = '';

    // Step 1: local mismatch check — do NOT call the API on mismatch
    const accNum = this.bankAccountForm.get('account_number')?.value;
    const confirmNum = this.bankAccountForm.get('confirm_account_number')?.value;
    if (accNum !== confirmNum) {
      this.bankAccountForm.get('confirm_account_number')?.markAsTouched();
      this.bankVerifyError = 'Account numbers do not match.';
      return;
    }

    if (!this.canVerifyBankAccount) {
      this.bankAccountForm.markAllAsTouched();
      return;
    }

    const ifsc = (this.bankAccountForm.get('ifsc_code')?.value || '').toUpperCase();

    this.isBankAccountVerifying = true;
    this.isBankAccountVerified = false;
    this.bankVerifyMessage = '';

    // Replaces the previous Razorpay IFSC lookup — now calls our own backend
    // via the existing HttpService (environment.apiUrl + auth headers are
    // already applied inside sendGetRequest, matching the rest of this file).
    const verifyUrl = URLUtils.bankAccountVerify.replace('{IFSC_CODE}', ifsc);

    this.httpservice.sendGetRequest(verifyUrl).subscribe({
      next: (res: any) => {
        this.isBankAccountVerifying = false;

        const data = res?.data ?? res;
        const bankName = data?.bank_name || '';
        const branchName = data?.branch_name || '';

        // Reactive form update: only bankName / branchName are ever patched here —
        // accountNumber, confirmAccountNumber, and accountHolderName are left untouched.
        if (bankName) {
          this.bankAccountForm.get('bank_name')?.setValue(bankName);
        }
        this.bankAccountForm.get('branch_name')?.enable({ emitEvent: false });
        this.bankAccountForm.get('branch_name')?.setValue(branchName);

        this.isBankAccountVerified = true;
        this.bankVerifyMessage = 'Bank account verified successfully.';
        this.lockVerifiedBankFields();
      },
      error: (error: HttpErrorResponse) => {
        this.isBankAccountVerifying = false;
        this.isBankAccountVerified = false;
        this.bankAccountForm.get('branch_name')?.setValue('');
        this.bankAccountForm.get('branch_name')?.disable({ emitEvent: false });

        this.bankVerifyError = error?.error?.msg || error?.error?.message || 'Bank account verification failed. Please try again.';
      }
    });
  }

  submitBankAccountDetails(): void {
    if (!this.isBankSubmitEnabled || this.isBankAccountSubmitting) return;

    this.isBankAccountSubmitting = true;
    const raw = this.bankAccountForm.getRawValue();
    // Confirm Account Number is intentionally excluded — backend contract
    // only accepts the fields below.
    const payload = {
      account_holder_name: raw.account_holder_name,
      account_number: raw.account_number,
      ifsc_code: raw.ifsc_code,
      bank_name: (raw.bank_name || '').trim(),
      branch_name: raw.branch_name,
      is_verified: true
    };

    this.httpservice.sendPostRequest(URLUtils.bankAccountAdd, payload).subscribe(
      (res: any) => {
        this.isBankAccountSubmitting = false;
        if (res && res.error === false) {
          const defaultMsg = this.bankAccountModalMode === 'edit'
            ? 'Bank account details updated successfully.'
            : 'Bank account details added successfully.';
          this.toast.success(res.msg || defaultMsg, 'Success');
          this.closeBankAccountModal();
          //this.getData(); // refresh Subscription Details so the "already added" state reflects the saved details
          this.loadBankAccountDetails(); // refresh the dedicated bank-account record backing the View/Edit dialog
        } else {
          this.toast.error(res?.msg || 'Unable to save bank account details. Please try again.', 'Error');
        }
      },
      (error: HttpErrorResponse) => {
        this.isBankAccountSubmitting = false;
        this.toast.error(error?.error?.msg || error?.error?.message || 'Unable to save bank account details. Please try again.', 'Error');
      }
    );
  }

  // ═══════════════════════════════════════════════════════════
  //  PLAN MODAL — OPEN / CLOSE
  // ═══════════════════════════════════════════════════════════

  openPlanModal(mode: 'upgrade' | 'downgrade'): void {

    // this.selectedProfessional = professional;
    this.planModalMode = mode;
    this.planModalData = null;
    this.planOptions = [];
    this.selectedPlanKey = '';
    this.downgradeReason = '';
    this.downgradeReasonError = '';
    this.showPlanModal = true;
    this.planModalLoading = true;

    this.httpservice.sendGetRequest(URLUtils.paymentPlan).subscribe(
      (response: any) => {
        if (response?.data) {
          this.planModalData = response.data;
          this.planOptions = mode === 'upgrade'
            ? (response.data.upgrade_options || [])
            : (response.data.downgrade_options || []);
          if (this.planOptions.length > 0) {
            this.selectedPlanKey = this.planOptions[0].key;
          }
        } else {
          this.toast.error('Failed to load plan options', 'Error');
          this.showPlanModal = false;
        }
        this.planModalLoading = false;
      },
      () => {
        this.toast.error('Failed to load plan options', 'Error');
        this.planModalLoading = false;
        this.showPlanModal = false;
      }
    );
  }

  closePlanModal(): void {
    this.showPlanModal = false;
    this.planModalData = null;
    this.planOptions = [];
    this.selectedPlanKey = '';
    this.planModalMode = null;
    // this.selectedProfessional = null;
    this.downgradeReason = '';
    this.downgradeReasonError = '';
  }

  // ═══════════════════════════════════════════════════════════
  //  PLAN MODAL — SUBMIT
  // ═══════════════════════════════════════════════════════════

  submitPlanChange(): void {
    if (!this.selectedPlanKey) return;

    if (this.planModalMode === 'downgrade' && !this.downgradeReason.trim()) {
      this.downgradeReasonError = 'Reason is required for downgrade';
      return;
    }

    this.isPlanSubmitting = true;
    this.spinnerService.show();

    const uid = this.profuid;
    const request$ = this.planModalMode === 'upgrade'
      ? this.httpservice.sendPostRequest(URLUtils.PlanUpgrade, { new_plan: this.selectedPlanKey })
      : this.httpservice.sendPostRequest(URLUtils.PlanDownGrade, { new_plan: this.selectedPlanKey, reason: this.downgradeReason.trim() });

    request$.subscribe(
      (response: any) => {
        if (response && !response.error) {
          this.toast.success(response.msg || 'Plan updated successfully', 'Success');
          this.closePlanModal();
        } else {
          this.toast.error(response?.msg || 'Failed to update plan', 'Error');
        }
        this.isPlanSubmitting = false;
        this.spinnerService.hide();
      },
      (error: any) => {
        this.toast.error(error?.error?.msg || 'Failed to update plan', 'Error');
        this.isPlanSubmitting = false;
        this.spinnerService.hide();
      }
    );
  }

  getSelectedPlanPricing(): any {
    return this.planOptions.find(p => p.key === this.selectedPlanKey)?.pricing || null;
  }

  
  onPayBill() {
    //this.toast.success('Payment processing...');
    this.router.navigate(['/subscribe']);
  }

  getDeviceIcon(deviceType: string): string {
    const type = deviceType?.toLowerCase() || '';

    if (type.includes('windows')) return 'fa-desktop';
    if (type.includes('mac')) return 'fa-laptop';
    if (type.includes('android') || type.includes('ios')) return 'fa-mobile-alt';

    return 'fa-globe';
  }

  hasUppercase(value: string): boolean {
  return /[A-Z]/.test(value || '');
}

hasLowercase(value: string): boolean {
  return /[a-z]/.test(value || '');
}

hasNumber(value: string): boolean {
  return /\d/.test(value || '');
}

hasSpecialCharacter(value: string): boolean {
  return /[@$!%*?&]/.test(value || '');
}
hasMinLength(value: string): boolean {
  return (value || '').length >= 8;
}

openCancelSubscriptionModal(): void {
  this.cancelSubscriptionError = null;
  this.showCancelSubscriptionModal = true;
}
closeCancelSubscriptionModal(): void {

  // Don't allow closing while API is processing
  if (this.isCancellingSubscription) {
    return;
  }

  this.showCancelSubscriptionModal = false;
  this.cancelSubscriptionError = null;
}


  openeMandateSubscriptionModal(): void {
    this.cancelSubscriptionError = null;
    this.showeMandateSubscriptionModal = true;
  }
  closeeMandateSubscriptionModal(): void {
    this.showeMandateSubscriptionModal = false;
  }

cancelSubscription(): void {
  //console.log('subscriptionId', this.subscriptionId);

  if (this.isCancellingSubscription) {
    return;
  }

  this.isCancellingSubscription = true;
  this.cancelSubscriptionError = null;

  let payload:any = {
    user_id: this.setLog.id
  }; 

  this.httpservice.sendIMPostRequest(URLUtils.cancelSubscription, payload).subscribe({
    next: (res: any) => {
      this.isCancellingSubscription = false;
      this.showCancelSubscriptionModal = false;
      this.toast.success(
        res?.msg || 'Subscription cancelled successfully.'
      );
      // Refresh subscription details
      this.getSettingsLog();
    },

    error: (err: any) => {

      console.error('Cancel subscription error:', err);

      this.isCancellingSubscription = false;

      // IMPORTANT:
      // Keep modal open when API returns an error
      this.showCancelSubscriptionModal = true;

      this.cancelSubscriptionError =
        err?.error?.msg ||
        err?.error?.message ||
        err?.error?.errors?.[0]?.msg ||
        err?.errors?.[0]?.msg ||
        'Unable to cancel your subscription. Please try again.';
    }

  });
}
}
